/**
 * Helpers for lander/offer weight totals and share labels.
 * For Media Devoted | Created By Ciro Autiero
 */

export function sumPathItemWeights(weights: number[]): number {
  return weights.reduce((acc, w) => {
    if (!Number.isFinite(w) || w < 0) return acc;
    return acc + w;
  }, 0);
}

export function formatWeightSharePercent(
  weight: number,
  total: number,
): string {
  if (!Number.isFinite(weight) || !Number.isFinite(total) || total <= 0) {
    return '—';
  }
  const pct = Math.min(100, Math.max(0, Math.round((weight / total) * 100)));
  return `${pct}%`;
}
